<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ExportBtn',
})
</script>
<template>
  <BdBtn type="primary" :icon="ExportOutlined" @click="handleExport" :loading="loading">
    <slot>全部导出</slot>
  </BdBtn>
</template>

<script lang="ts" setup name="ExportBtn">
import { ExportOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { ref } from 'vue'
import { BdBtn } from '-/Common/BdBtn'

const props = defineProps<{
  api: BD.PromiseFn<any>
  params?: Record<string, any>
}>()

const loading = ref(false)
const handleExport = async () => {
  loading.value = true
  try {
    await props.api({
      conditions: props.params?.conditions,
      ids: props.params?.ids
    })
    message.success('导出任务已启动，请稍后在消息中心查看')
  } catch (error) {
    console.error(error)
  } finally {
    loading.value = false
  }
}
</script>
